export const Emit_Event = {
    UPDATE_MODELS: "UPDATE_MODELS", // 更新model，重新查询
    LOADING_DXF: "LOADING_DXF", // 导入dxf加载
}